import axios from 'axios';
import { CountryCode, addressToString } from '../index.js';
import { axiosConciseErrorInterceptor } from '../util/axios.js';
import { findDKAccessAddress, findDKAddressId } from './adressevaelger.js';
export const isAddressInDenmark = (address, tenant) => {
    if (!address.country?.trim()) {
        if (tenant) {
            return tenant.countryCode === CountryCode.DK;
        }
        else {
            return true;
        }
    }
    else {
        return ['dk', 'danmark', 'denmark'].includes(address.country.trim().toLowerCase());
    }
};
let client = axios.create();
client.interceptors.response.use((res) => res, axiosConciseErrorInterceptor);
const toLookupText = (address) => addressToString(address, { noCoAddress: true, noCountry: true });
export const addressToAddressId = async (address, tenant) => {
    if (!isAddressInDenmark(address, tenant)) {
        return null;
    }
    if (address.DK_AdresseId) {
        return address.DK_AdresseId;
    }
    if (!Object.values(address).some((v) => v)) {
        return null;
    }
    return await findDKAddressId(toLookupText(address));
};
export const addressToBFE = async (address) => {
    if (address.BFE) {
        return address.BFE;
    }
    if (!Object.values(address).some((v) => v)) {
        return null;
    }
    const addressId = await addressToAddressId(address);
    if (addressId) {
        const bfeRes = await axios
            .get(`https://services.datafordeler.dk/DAR/DAR_BFE_Public/1/rest/adresseTilEnhedBfe?adresseId=${addressId}&username=YAXUSMNHMR&password=Password123+`)
            .then((r) => r.data);
        if (bfeRes && bfeRes.length) {
            return bfeRes[0];
        }
    }
    // Without floor or door we can't pick a unit, but the building still has a BFE
    const husNrRes = addressId
        ? await client
            .get(`https://services.datafordeler.dk/DAR/DAR/3.0.0/rest/adresseTilHusnummer?adresseId=${addressId}`)
            .then((r) => r.data)
        : (await findDKAccessAddress(toLookupText(address)))?.id;
    if (!husNrRes) {
        console.error('[addressToBFE] no address found for address', address);
        return null;
    }
    const husnrBFERes = await client
        .get(`https://services.datafordeler.dk/DAR/DAR_BFE_Public/1/rest/husnummerTilBygningBfe?HusnummerId=${husNrRes}&&username=YAXUSMNHMR&password=Password123+`)
        .then((r) => r.data);
    if (Array.isArray(husnrBFERes.bygningPaaFremmedGrundList) &&
        husnrBFERes.bygningPaaFremmedGrundList[0] != null) {
        return `${husnrBFERes.bygningPaaFremmedGrundList[0]}`;
    }
    if (!husnrBFERes ||
        !husnrBFERes.jordstykkeList ||
        !husnrBFERes.jordstykkeList.length) {
        return null;
    }
    return husnrBFERes.jordstykkeList[0].samletFastEjendom;
};
//# sourceMappingURL=index.js.map